import { useState } from "react"

export const useGlobalStates = () => {
    // para el formulario
    const [showForm, setShowForm] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState("EDITABLE")

    // para la modal
    const [showModalDeposit, setShowModalDeposit] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState("EDITABLE")
    const [showTypeForm, setshowTypeForm] = useState("None")

    // para el steper
    const [stepApplilication, setStepApplilication] = useState(0)

    // ✅ para contenido de garantías (HOME / IMAGE)
    const [showSection, setShowSection] = useState("HOME")
    const [imagesCurrentIndex, setImagesCurrentIndex] = useState(0)

    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        stepApplilication, setStepApplilication,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        showTypeForm, setshowTypeForm,

        // ✅ nuevos (paridad con Gestores)
        showSection, setShowSection,
        imagesCurrentIndex, setImagesCurrentIndex,
    })
}